import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";

const useSlippageCardStyles = makeThemedStyles("SlippageCard", (theme) => ({
  slippageContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  container: {
    display: "flex",
    justifyContent: "space-around",
    width: "100%",
    alignItems: "center",
    minHeight: "207.5px",
    border: "1px solid #EBEFEF",
    borderRadius: "2.28em",
  },
  largeText: {
    color: "#102975",
    fontSize: "32px",
    fontWeight: 600,
    lineHeight: "0.75em",
  },
  text: {
    color: "#656A72",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "1.21em",
  },
  sign: {
    color: "rgb(14,156,240)",
  },
  unit: { fontSize: "16px", marginInlineStart: "0.5em" },
}));
export default useSlippageCardStyles;
